import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-ras-number',
  templateUrl: './ras-number.component.html',
  styleUrls: ['./ras-number.component.scss'],
})
export class RasNumberComponent implements OnInit {
  constructor(
    private readonly dialogRef: MatDialogRef<RasNumberComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly fb: FormBuilder
  ) {}

  ngOnInit() {}

  form = this.fb.group({
    num: ['', [Validators.required]],
    observation: ['', [Validators.required]],
  });

  close() {
    this.dialogRef.close({ status: false });
  }
  closeOk() {
    this.dialogRef.close({ status: true, value: this.form.value });
  }
}
